import { render } from "./HomePaperCenter.vue?vue&type=template&id=9f43c66a&scoped=true"
import script from "./HomePaperCenter.vue?vue&type=script&lang=js"
export * from "./HomePaperCenter.vue?vue&type=script&lang=js"

import "./HomePaperCenter.vue?vue&type=style&index=0&id=9f43c66a&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f43c66a"]])

export default __exports__